








































































































































































































































































































































































































































































































import Vue from "vue";

import store, { CashFlowStore } from "../services/CashFlowStore";
import RiportItemDetailsPopup from "./RiportItemDetailsPopup.vue";
import IconButton from "@/components/IconButton.vue";
import { CashFlowRiportGroupItemsDefaultProps } from "../models/CashFlowRiportGroupItem";
import { CashFlowRiportGroupDefaultProps } from "../models/CashFlowRiportGroup";
import MoneyInput from "@/components/MoneyInput.vue";

interface Data {
  store: CashFlowStore;
  oldProfitPercent: number;
  oldPlanProfitAmount: number;
  remainPlanProfitPercent: number;
  remainPlanProfitAmount: number;
  headInEdit: { 
    planProfitAmount: boolean; 
    openCashAmount: boolean;
  };
  showPlanAmount: boolean;
  expandProfitList: boolean;
  expandNonProfitList: boolean;
  closedMonths: boolean[];
  newCFIndex: number;
  newGLGroupIndex: number;
  newGLRepRowIndex: number;
}

interface Methods {
  toggleFieldEdit(event: Event, item?: any): void;
  toggleExpandList(list: string): void;
  updateData(item: any): void;
  closeMonth(month: number): void;
  closeOpenAmount(): void;
  calcRemainPlanProfit(): void;
  calcBalance(): void;
  createProfitItem(): void;
  createNonProfitItem(): void;
}

interface Computed {
  outcomeGroup(): any;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    RiportItemDetailsPopup,
    IconButton,
    MoneyInput
  },

  async beforeMount() {
    this.calcRemainPlanProfit();

    this.closedMonths = this.closedMonths.map((_, index) => {
      const group = this.store.nonProfitGroups.find(g => g.dateMonth == index + 1);
      return group?.isClosed || false; 
    });
    this.calcBalance();
  },

  mounted() {
    this.toggleExpandList('profit');
    this.toggleExpandList('nonprofit');

    this.$nextTick(() => {
      this.$emit('ready', this.$refs.editTableContainer);
    });
  },

  data() {
    return {
        store,
        oldProfitPercent: 0,
        oldPlanProfitAmount: 0,
        remainPlanProfitPercent: 0,
        remainPlanProfitAmount: 0,
        headInEdit: {
          planProfitAmount: false,
          openCashAmount: false
        },
        expandProfitList: true,
        expandNonProfitList: true,
        showPlanAmount: true,
        closedMonths: Array(12).fill(false),
        newCFIndex: 0,
        newGLGroupIndex: 0,
        newGLRepRowIndex: 0
    };
  },

  methods: {
    toggleFieldEdit(event, item) {
      if (!this.store.userPermissions.canEdit) { return; }
      if (!this.showPlanAmount) { return; }

      const td = (event.target as HTMLElement).closest('td');
      const textDiv = td?.querySelector('.td-text') as HTMLElement;
      const inputDiv = td?.querySelector('.v-input') as HTMLElement;
      const input = td?.querySelector('input') as HTMLInputElement;

      switch(event.type) {
        case "click":
          this.oldProfitPercent = item?.planProfitPerc ?? this.store.profitGroups.find(g => g.id == item?.group && g.name == "Eredmény")?.planProfitPerc;
          this.oldPlanProfitAmount = item?.planProfitAmount ?? item?.planAmount;
          textDiv.style.display = "none";
          inputDiv.style.display = "";
          input.closest('tr')?.classList.add('highlight');
        break;
        case "blur":
          this.updateData(item);
          this.$nextTick(() => {
            this.calcBalance();
          });
          textDiv.style.display = "";
          inputDiv.style.display = "none";
          input.closest('tr')?.classList.remove('highlight');  
        break;
      }
      this.$nextTick(() => {
        input.focus();
        input.select();
      });
    },

    updateData(item) {
      //Ha group item szerkesztés történt
      /*
      # Szabályok:
      # 1, Ha a kiadás tételek értékét a hónapban módosítom, akkor a havi összesítettet is újraszámolom
      # 2, PIVOT FIX: Ha a tétel nevét szekesztjük, minden rowid-s tétel nevét ugyanarra fogjuk szerkeszteni
      # 3, LOGIC FIX?: Az eredmény csoportban az eredmény tétel értékét mindig egyenlővé tesszük a csoport planamountjával,
      # mert csak így lehet maszkolni az eredményeket
      */
      if (typeof item?.planAmount != "undefined" && item.planAmount == null || item.planAmount == "") { item.planAmount = 0; }
      if (typeof item?.planProfitAmount != "undefined" && item.planProfitAmount == null || item.planAmount == "") { item.planProfitAmount = 0; }
      if (typeof item?.planProfitPerc != "undefined" && item.planProfitPerc == null || item.planProfitPerc == "") { item.planProfitPerc = 0; }
      if ((typeof item.name == 'string' && item.name.trim() === '')) { item.name = "-"; }

      let groupData = this.store.cashFlowRiportGroups.find(i => i.id == item?.group);
      if(groupData) {
        if (!groupData.isProfit) {
          const groupItemsData = this.store.cashFlowRiportGroupItems.filter(i => i.group == item.group);
          const monthSum = groupItemsData.reduce((sum, item) => sum + item.planAmount, 0);
          groupData.planProfitAmount = monthSum;
        }
        if (groupData.isProfit) {
            const outcomeMonthGroup = this.store.profitGroups.find(g => g.id == item.group && g.name == "Eredmény");
            if (outcomeMonthGroup && item.name == "Eredmény" && this.store.cashFlowRiportHead.planProfitAmount != 0) {
              outcomeMonthGroup.planProfitAmount = item.planAmount;
              outcomeMonthGroup.planProfitPerc = (item.planAmount / this.store.cashFlowRiportHead.planProfitAmount) * 100;

              const monthSum = this.store.profitGroups.reduce((sum, item) => sum + item.planProfitAmount, 0);
              const monthPercSum = this.store.profitGroups.reduce((sum, item) => sum + item.planProfitPerc, 0);

              if(monthSum > this.store.cashFlowRiportHead.planProfitAmount && monthPercSum > 100) {
                outcomeMonthGroup.planProfitPerc = this.oldProfitPercent;
                outcomeMonthGroup.planProfitAmount = item.planAmount = this.oldPlanProfitAmount;                
              }
              this.calcRemainPlanProfit();
            }
        }
      }
      else {
        this.store.cashFlowRiportGroupItems.filter(i => i.reportRow == item.reportRow).forEach(group => {
          group.name = item.name;
        })
      }
      groupData = undefined;

      //Ha group szerkesztés történt
      /*
      # Szabályok:
      # 1, Ha az eredmény % -ot módosítom, akkor a tényleges érték is módosul és ugyan ez fordítva
      # 2, LOGIC FIX?: A csoport planamountot visszírom a tétel planamountba, mert csak így lehet maszkolni az eredményt ezt mentéskor 0-zom!
      # 3, A havi szintre lebontott eredmény nem lépheti túl a várható eredményt. Ha így történik nem mentek és visszatöltöm az eredeti értékeket.
      # 4, Fennamradó eredményt újraszámolom módosításkor
      */
      groupData = this.store.cashFlowRiportGroups.find(i => i.id == item?.id && typeof item?.group == "undefined" && typeof item?.year == "undefined");
      if(groupData) {
        if(groupData.isProfit) {
          const monthSum = this.store.profitGroups.reduce((sum, item) => sum + item.planProfitAmount, 0);
          const monthPercSum = this.store.profitGroups.reduce((sum, item) => sum + item.planProfitPerc, 0);
          const monthItem = this.store.profitGroupItems.find(g => g.items.find(i => i.group == item.id))?.items.find(i => i.group == item.id);

          if (monthItem) {
            if(monthSum <= this.store.cashFlowRiportHead.planProfitAmount && monthPercSum <= 100) {
              if(groupData.planProfitPerc == this.oldProfitPercent) {
                groupData.planProfitPerc = (item.planProfitAmount / this.store.cashFlowRiportHead.planProfitAmount) * 100;
              }
              else {
                groupData.planProfitAmount = this.store.cashFlowRiportHead.planProfitAmount * (groupData.planProfitPerc / 100);
                monthItem.planAmount = groupData.planProfitAmount;
              }
            }
            else {
              groupData.planProfitPerc = this.oldProfitPercent;
              groupData.planProfitAmount = this.oldPlanProfitAmount;
              monthItem.planAmount = this.oldPlanProfitAmount;
            }
          }
          this.calcRemainPlanProfit();
        }
      }
      groupData = undefined;

      //Ha fejléc szerkesztés történik
      /*
      # Szabályok:
      # 1, Ha a várható eredmény módosul az összes hónapot befrissítjük % alapján
      */
      groupData = this.store.cashFlowRiportGroups.find(i => i.head == item?.id && typeof item?.group == "undefined" && typeof item?.planAmount == "undefined");
      if(groupData) {                  
        this.store.profitGroups.forEach(group => {
          group.planProfitAmount = (this.store.cashFlowRiportHead.planProfitAmount * group.planProfitPerc) / 100;
          const monthItem = this.store.profitGroupItems.find(g => g.name == "Eredmény" && g.items.find(i => i.group == group.id))?.items.find(i => i.group == group.id);
          if (monthItem) {
            monthItem.planAmount = group.planProfitAmount;            
          }
        });
        this.calcRemainPlanProfit();
      }
      groupData = undefined;
    },

    closeMonth(month) {
      this.store.cashFlowRiportGroups.filter(g => g.dateMonth == month).map(g => g.isClosed = !g.isClosed);
      this.closedMonths[month-1] = !this.closedMonths[month-1];
      this.calcBalance();
    },

    closeOpenAmount() {
      this.store.openAmountGroup.isClosed = !this.store.openAmountGroup.isClosed;
      this.calcBalance();
    },

    toggleExpandList(list) {
      if (list == "profit") {
        this.expandProfitList = !this.expandProfitList; 
        (this.$refs.profitTableBody as HTMLElement).classList.toggle("full-screen");      
      }
      else {
        this.expandNonProfitList = !this.expandNonProfitList; 
        (this.$refs.nonProfitTableBody as HTMLElement).classList.toggle("full-screen");      
      }
    },

    calcRemainPlanProfit() {
      this.remainPlanProfitPercent = 100 - this.store.profitGroups.reduce((sum, item) => sum + item.planProfitPerc, 0);
      this.remainPlanProfitAmount = this.store.cashFlowRiportHead.planProfitAmount * (this.remainPlanProfitPercent/100);
    },

    calcBalance() {            
      const cashOpenAmount = this.store.openAmountGroup.isClosed ? this.store.openAmountGroupItem.amount : this.store.cashFlowRiportHead.cashOpenAmount;

      for(let i = 0; i < 12; i++) {
        const profitMoths = this.store.profitGroups.filter(g => g.dateMonth == (i+1));
        const profitMonthPlanAmount = this.store.profitGroupItems?.reduce((sum, item) => {
          return sum + (item.items?.find(x => x.month == i + 1)?.planAmount || 0); 
        }, 0);
        const profitMonthTrueAmount = this.store.profitGroupItems?.reduce((sum, item) => {
          return sum + (item.items?.find(x => x.month == i + 1)?.amount || 0); 
        }, 0);
        
        const nonProfitMoth = this.store.nonProfitGroups.find(g => g.dateMonth == (i+1));
        const nonProfitMonthPlanAmount = nonProfitMoth?.planProfitAmount;
        const nonProfitMonthTrueAmount = this.store.nonProfitGroupItems?.reduce((sum, item) => {
          return sum + (item.items?.find(x => x.month == i + 1)?.amount || 0); 
        }, 0);
        
        let planBalance = 0;
        let trueBalance = 0;
                
        if(typeof profitMonthPlanAmount != "undefined" && typeof nonProfitMonthPlanAmount != "undefined"&& typeof nonProfitMonthTrueAmount != "undefined") {     
          if(i == 0) {
            planBalance = cashOpenAmount + profitMonthPlanAmount + nonProfitMonthPlanAmount;
            trueBalance = cashOpenAmount + profitMonthTrueAmount + nonProfitMonthTrueAmount;
          }
          else {
            trueBalance = this.store.cashBalance[i-1].trueBalance + profitMonthTrueAmount + nonProfitMonthTrueAmount;
            if (this.closedMonths[i]) {
              trueBalance = this.store.cashBalance[i-1].trueBalance + (this.closedMonths[i] ? profitMonthTrueAmount : profitMonthPlanAmount) + (this.closedMonths[i] ? nonProfitMonthTrueAmount : nonProfitMonthPlanAmount);
            }
            planBalance = (this.closedMonths[i-1] ? this.store.cashBalance[i-1].trueBalance : this.store.cashBalance[i-1].planBalance) + profitMonthPlanAmount + nonProfitMonthPlanAmount;              
          }
          this.store.cashBalance[i].nonProfitMonthTrueAmount = nonProfitMonthTrueAmount;
          this.store.cashBalance[i].planBalance = planBalance;
          this.store.cashBalance[i].trueBalance = trueBalance;
        }
      }
      this.store.cashBalance = {...this.store.cashBalance};      
    },

    createProfitItem() {
      this.newGLGroupIndex--;
      this.newGLRepRowIndex--;

      for (let i = 1; i < 13; i++) {
        this.newCFIndex--;
        
        this.store.cashFlowRiportGroupItems.push({
          ...CashFlowRiportGroupItemsDefaultProps,
          id: this.newCFIndex,
          name: {...CashFlowRiportGroupDefaultProps}.name,
          group: this.store.profitGroups[i - 1].id,
          month: i,
          reportRow: this.newGLRepRowIndex,
        })
      }
      
      store.generatePivotForProfitGroupItems();
    },

    createNonProfitItem() {
      this.newGLGroupIndex--;
      this.newGLRepRowIndex--;

      for (let i = 1; i < 13; i++) {
        this.newCFIndex--;
        
        this.store.cashFlowRiportGroupItems.push({
          ...CashFlowRiportGroupItemsDefaultProps,
          id: this.newCFIndex,
          name: {...CashFlowRiportGroupDefaultProps}.name,
          group: this.store.nonProfitGroups[i - 1].id,
          month: i,
          reportRow: this.newGLRepRowIndex,
        })
      }
      
      store.generatePivotForNonProfitGroupItems();
    },
  },
});
